export default __webpack_public_path__ + "static/media/landing.6fa0380a.jpg";